import React from 'react';

import { useAppSelector } from '../../hooks';
import { SelectionWindowSettingsFloatingBox } from './SelectionWindowSettingsFloatingBox';
import {
  getDistanceSnappingLevelStatus,
  SnappingLevelFloatingBoxAndEventListeners,
} from './SnappingLevelFloatingBoxAndEventListeners';

export function MutuallyExclusiveCurrentInteractionSettingsBoxes() {
  const snappingStatus = useAppSelector(getDistanceSnappingLevelStatus);

  return snappingStatus.active ? <SnappingLevelFloatingBoxAndEventListeners /> : <SelectionWindowSettingsFloatingBox />;
}
